import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { VideoListAll } from './VideoListAll';
import { VideoView } from './VideoView';

export const VideoPage = ()=>{
    return (
        <Routes>
            <Route path="/" element={ <VideoListAll /> } />
            <Route path="/view/:id" element={ <VideoView /> } />
        </Routes>
    );
};